// extracted by mini-css-extract-plugin
export default {"root":"PaymentAllocation_root__rCeoA","amount":"PaymentAllocation_amount__9NW59"};